import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68bb7e56"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "badge"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g transform=\"translate(-8.536 -0.016)\" data-v-68bb7e56><path d=\"M0-4.37l27.5-28.4L55-4.37V415.281L27.772,446.613,0,415.281Z\" transform=\"translate(220.728 32.787)\" data-v-68bb7e56></path><path d=\"M0-4.37l27.5-28.4L55-4.37V415.281L27.772,446.613,0,415.281Z\" transform=\"matrix(0.966, 0.259, -0.259, 0.966, 275.22, 32.72)\" data-v-68bb7e56></path><path d=\"M0-4.37l27.5-28.4L55-4.37V415.281L27.772,446.613,0,415.281Z\" transform=\"translate(327.873 46.759) rotate(30)\" data-v-68bb7e56></path><path d=\"M0-4.37l27.5-28.4L55-4.37V415.281L27.772,446.613,0,415.281Z\" transform=\"translate(375.098 73.947) rotate(45)\" data-v-68bb7e56></path><path d=\"M0-4.37l27.5-28.4L55-4.37V415.281L27.772,446.613,0,415.281Z\" transform=\"translate(413.677 112.432) rotate(60)\" data-v-68bb7e56></path><path d=\"M0-4.37l27.5-28.4L55-4.37V415.281L27.772,446.613,0,415.281Z\" transform=\"matrix(0.259, 0.966, -0.966, 0.259, 440.981, 159.59)\" data-v-68bb7e56></path><path d=\"M0-4.37l27.5-28.4L55-4.37V415.281L27.772,446.613,0,415.281Z\" transform=\"translate(455.149 212.208) rotate(90)\" data-v-68bb7e56></path><path d=\"M0-4.37l27.5-28.4L55-4.37V415.281L27.772,446.613,0,415.281Z\" transform=\"matrix(-0.259, 0.966, -0.966, -0.259, 455.216, 266.7)\" data-v-68bb7e56></path><path d=\"M0-4.37l27.5-28.4L55-4.37V415.281L27.772,446.613,0,415.281Z\" transform=\"translate(441.177 319.353) rotate(120)\" data-v-68bb7e56></path><path d=\"M0-4.37l27.5-28.4L55-4.37V415.281L27.772,446.613,0,415.281Z\" transform=\"translate(413.988 366.578) rotate(135)\" data-v-68bb7e56></path><path d=\"M0-4.37l27.5-28.4L55-4.37V415.281L27.772,446.613,0,415.281Z\" transform=\"translate(375.504 405.157) rotate(150)\" data-v-68bb7e56></path><path d=\"M0-4.37l27.5-28.4L55-4.37V415.281L27.772,446.613,0,415.281Z\" transform=\"matrix(-0.966, 0.259, -0.259, -0.966, 328.346, 432.461)\" data-v-68bb7e56></path></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "badge-text-container" }
const _hoisted_5 = {
  class: "background-svg",
  xmlns: "http://www.w3.org/2000/svg",
  width: "3840",
  height: "2160",
  viewBox: "0 0 3840 2160"
}
const _hoisted_6 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", {
        class: "layout__container",
        key: _ctx.liveRevision
      }, [
        (_ctx.item.showBadge)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(), _createElementBlock("svg", {
                class: "badge-svg",
                xmlns: "http://www.w3.org/2000/svg",
                style: _normalizeStyle( { fill: _ctx.item.badgeColor }),
                width: "479.384",
                height: "479.384",
                viewBox: "0 0 479.384 479.384"
              }, _hoisted_3, 4)),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: _ctx.item.badgeFontColor })
                }, _toDisplayString(_ctx.item.badge), 5)
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(), _createElementBlock("svg", _hoisted_5, [
          _createElementVNode("path", {
            d: "M0,0H840V170H130V1991H840v169H0Z",
            style: _normalizeStyle({ fill: _ctx.item.backgroundColor1 })
          }, null, 4),
          _createElementVNode("path", {
            d: "M2902,0H-103V170H612V1991H-103v169H2902Z",
            transform: "translate(938)",
            style: _normalizeStyle({ fill: _ctx.item.backgroundColor2 })
          }, null, 4)
        ])),
        _createElementVNode("div", {
          class: "img",
          style: _normalizeStyle({ background: 'url(' + _ctx.item.media.asset1_url + ') center center no-repeat', backgroundSize: 'cover' })
        }, null, 4),
        _createElementVNode("section", _hoisted_6, [
          (_ctx.item.headline)
            ? (_openBlock(), _createElementBlock("h1", {
                key: 0,
                style: _normalizeStyle({ color: _ctx.item.fontColor }),
                class: "heading textfit__headline"
              }, _toDisplayString(_ctx.item.headline), 5))
            : _createCommentVNode("", true),
          (_ctx.item.secondaryHeadline)
            ? (_openBlock(), _createElementBlock("h2", {
                key: 1,
                style: _normalizeStyle({color: _ctx.item.fontColor }),
                class: "sub-heading textfit__secondary-headline"
              }, _toDisplayString(_ctx.item.secondaryHeadline), 5))
            : _createCommentVNode("", true),
          (_ctx.item.descriptions.length)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 2,
                style: _normalizeStyle({ color: _ctx.item.fontColor }),
                class: "list textfit__description"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.descriptions, (description, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _createElementVNode("span", null, _toDisplayString(description), 1)
                  ]))
                }), 128))
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.item.showBanner)
            ? (_openBlock(), _createElementBlock("span", {
                key: 3,
                style: _normalizeStyle([Boolean(_ctx.item.banner.trim()) ? { color: _ctx.item.bannerFontColor, background: _ctx.item.bannerColor } : { background: _ctx.none }]),
                class: "banner textfit__banner"
              }, _toDisplayString(_ctx.item.banner), 5))
            : _createCommentVNode("", true)
        ]),
        (_ctx.item.useCompanyBrandingImage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "img-two",
              style: _normalizeStyle({ background: 'url(' + _ctx.item.media.asset2_url + ') bottom right no-repeat', backgroundSize: 'contain' })
            }, null, 4))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}